import axios from "axios";
import React, { use, useEffect, useState } from "react";
import { redirect, useNavigate } from "react-router-dom"; // Use useNavigate from v6
import './Home.css';
import { PencilSquare, Trash, Image, Link45deg } from "react-bootstrap-icons";
import { MdExpandLess, MdExpandMore, MdExpandCircleDown } from "react-icons/md";
import {AlertModal} from "../components/AlertModal/AlertModal";

export default function Home() {
  const [addUser, setAddUser] = useState({});
  const [users, setUsers] = useState([]);
  const [groupedUsers, setGroupedUsers] = useState({});
  const [competitions] = useState(["TopWeb", "BestWeb"]);
  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);
  const [badges, setBadges] = useState([]);
  const [awardTypes, setAwardTypes] = useState([]);
  // const [redirectLinks] = useState(["https://topweb.lk/", "https://www.bestweb.lk/"]);
  const [clicked, setClicked] = useState(false);
  const [expand, setExpand] = useState({});
  const [expandGroup, setExpandGroup] = useState({});
  const [searchInput, setSearchInput] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("")
  const [color, setColor] = useState("")
  const token = localStorage.getItem("token");
  const REACT_APP_ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;
  const REACT_APP_USER_API_URL = process.env.REACT_APP_USER_API_URL;



  const navigate = useNavigate();

  // Check for token on mount and redirect to login if missing
  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token, navigate]);

  // Fetch data on mount if token exists
  useEffect(() => {
    if (token) {
      getUsers();
      getBadges();
      getPeriods();
      getAwardTypes();
    }
  }, [token]);

  useEffect(() => {
    categorizeUsers();
  }, [users]);

  const getPeriods = async () => {
    try {
      const response = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1/periods`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      response.data.forEach((period) => {
        if (period.competition.id === 1) {
          setYears((prev) => [...prev, period.name]);
        } else if (period.competition.id === 2) {
          setMonths((prev) => [...prev, period.name]);
        }
      });
    } catch (e) {
      if (e.response?.status === 401) {
        //console.log("Unauthorized when fetching periods");
        handleUnauthorized();
      } else {
        //console.log("Error when fetching periods");
      }
    }
  };

  const getAwardTypes = async() =>{
    try{
      const response = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1/awardTypes`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const types = response.data.map((type) => type.name);
      setAwardTypes(types);
    } catch (e) {
      if (e.response?.status === 401) {
        //console.log("Unauthorized when fetching badges");
        handleUnauthorized();
        return
      } else {
        //console.log("Error when loading award types");
        //console.log(e);
      }
    }
  }

  const getBadges = async () => {
    try {
      const response = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1/badge-store`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const badges = response.data.map((badge) => badge.name);
      setBadges(badges);
    } catch (e) {
      if (e.response?.status === 401) {
        //console.log("Unauthorized when fetching badges");
        handleUnauthorized();
      } else {
        //console.log("Error when loading badges");
        //console.log(e);
      }
    }
  };

  const getUsers = async () => {
    try {
      setExpandGroup({});
      
      const result = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(result.data);
      //console.log("Data fetched...");
    } catch (error) {
      if (error.response?.status === 401) {
        //console.log("Unauthorized when fetching users");
        handleUnauthorized();
      } else {
        //console.log("Error fetching users");
      }
    }
  };

  const categorizeUsers = () => {
    let dic = {};
    let expandState = {};
    users.forEach((user) => {
      if (!dic[user.name]) {
        dic[user.name] = [];
        expandState[user.name] = false;
      }
      dic[user.name].push({
        id: user.id || "",
        competition: user.competition || "",
        period: user.period || "",
        badge: user.badge || "",
        redirectLink: user.redirectLink || "",
        awardType : user.awardType || ""
      });
    });
    setGroupedUsers(dic);
    setExpand(expandState);
  };

  const handleChange = async (user, key) => {

    user.redirectLink = user.redirectLink.trim()

    if(user.redirectLink == ""){
        setShowAlert(true)
        setColor("red")
        setMessage("Redirect Link is empty")
        return
    }
    user["name"] = key;
    try {
      const response = await axios.put(`${REACT_APP_ADMIN_API_URL}/api/v1`, user, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setShowAlert(true)
      setColor("green")
      setMessage(response.data);
      getUsers(); // Refresh the data after saving
    } catch (error) {
      //console.log(error)
      if (error.response?.status === 401) {
        handleUnauthorized();
      } else {
        setShowAlert(true)
        setColor("red")
        setMessage(error.response?.data || "An unexpected error occurred. Please try again.");
      }
    }
  };

  const handleAdd = async (websiteName, newUser) => {
    websiteName = websiteName.trim()
    newUser.redirectLink = newUser.redirectLink.trim()

    const userToAdd = { ...newUser, name: websiteName };

    if(websiteName ==="" || userToAdd.redirectLink ===""){
      setShowAlert(true)
      setColor("red")
      setMessage("Can't Add empty fields")
      return
    }
    try {
      const response = await axios.post(`${REACT_APP_ADMIN_API_URL}/api/v1`, userToAdd, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setShowAlert(true)
      setColor("green")
      setMessage(response.data);
      setAddUser({ name: "", competition: "", period: "", awardType:"", badge: "", redirectLink: "" });
      if (clicked) setClicked(false);
      getUsers(); // Refresh table
    } catch (error) {
      if (error.response?.status === 401) {
        handleUnauthorized();
      } else {
        setShowAlert(true)
        setColor("red")
        setMessage(error.response?.data || "An unexpected error occurred. Please try again.");
      }
    }
  };

  const handleDelete = async (user) => {

    const confirmed = window.confirm("Do you want to delete this decision? This action is irreversible");
    if (!confirmed) {
      return
    }
    
    try {
      const response = await axios.delete(`${REACT_APP_ADMIN_API_URL}/api/v1/${user.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      
      getUsers();
    } catch (error) {
      if (error.response?.status === 401) {
        handleUnauthorized();
      } else {
        setShowAlert(true)
        setColor("red")
        setMessage("Error");
      }
    }
  };

  const getAddUserState = (website) => {
    if (!addUser[website]) {
      setAddUser((prev) => ({
        ...prev,
        [website]: { name: "", competition: "", period: "", awardType:"", badge: "", redirectLink: "" },
      }));
      return { name: "", competition: "", period: "", awardType:"", badge: "", redirectLink: "" };
    }
    return addUser[website];
  };

  const handleExpand = (user, flag) => {
    if (flag === 1) {
      setExpandGroup((prev) => ({ ...prev, [user]: groupedUsers[user] }));
      setExpand((prev) => ({ ...prev, [user]: true }));
    } else {
      const updatedExpand = { ...expandGroup };
      delete updatedExpand[user];
      setExpandGroup(updatedExpand);
      setExpand((prev) => ({ ...prev, [user]: false }));
    }
  };

  const handleSearch = () => {
    const trimmedInput = searchInput.trim();
    if (!trimmedInput) {
      getUsers();
      return;
    }

    let dic = {};
    users.forEach((user) => {
      if (!dic[user.name]) {
        dic[user.name] = [];
      }
      dic[user.name].push({
        id: user.id || "",
        competition: user.competition || "",
        period: user.period || "",
        badge: user.badge || "",
        redirectLink: user.redirectLink || "",
        awardType : user.awardType || ""
      });
    });

    Object.keys(dic).forEach((key) => {
      if (!key.toLowerCase().includes(trimmedInput.toLowerCase())) {
        delete dic[key];
      }
    });

    setGroupedUsers(dic);
  };

  const handleCopyImage = (user, name) => {
    const url = `${REACT_APP_USER_API_URL}/eBadgeSystem/domainNames/${name}/${user.competition}/${user.period}/${user.awardType}/image.png`;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setMessage("Image URL copied!")
        setColor("green")
        setShowAlert(true)
  })
      .catch(() => {
        setMessage("Failed to copy Image URL")
        setColor("red")
        setShowAlert(true)
  });
  };

  const handleCopyLink = (user, name) => {
    const url = `${REACT_APP_USER_API_URL}/api/v1/clicked/${name}/${user.competition}/${user.period}/${user.awardType}`;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setShowAlert(true)
        setColor("green")
        setMessage("Link copied")})
      .catch(() => {
        setMessage("Failed to copy Link")
        setColor("red")
        setShowAlert(true)
  });
  };

  // Handle unauthorized access (e.g., token expired or invalid)
  const handleUnauthorized = () => {
    localStorage.removeItem("token"); // Clear invalid token
    //console.log("Session expired. Please log in again.");
    navigate("/login");
  };

  // Render nothing if no token (redirect handled by useEffect)
  if (!token) return null;

  return (
    <div className="container" style={{ marginLeft: 100 }}>
        {showAlert && (
        <AlertModal
          message={message}
          color={color}
          onClose={() => {
            setShowAlert(false)
            setMessage("")
            setColor("")
          }}
        />
      )}

      <div className="search-container">
        <input
          type="text"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          placeholder="Search by website name..."
          className="search-input"
        />
        <button onClick={handleSearch} className="search-icon">
          Search
        </button>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Website Name</th>
            <th scope="col">Competition</th>
            <th scope="col">Period</th>
            <th scope="col">Award Type</th>
            <th scope="col">Badge</th>
            <th scope="col">Redirect Link</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {/* Add new row for adding a completely new website */}
          <tr>
            {clicked ? (
              <>
                <td>
                  <input
                    className="form-control"
                    value={addUser["newWebsite"]?.name || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        ["newWebsite"]: { ...prev["newWebsite"], name: e.target.value },
                      }))
                    }
                    placeholder="Enter New Website Name"
                  />
                </td>
                <td>
                  <select
                    className="form-select"
                    value={addUser["newWebsite"]?.competition || ""}
                    onChange={(e) =>{
                      setAddUser((prev) => ({
                        ...prev,
                        ["newWebsite"]: { ...prev["newWebsite"], competition: e.target.value , period :""},
                      }))
                    }}
                  >
                    <option value="">Select Competition</option>
                    {competitions.map((competition, j) => (
                      <option key={j} value={competition}>
                        {competition}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    className="form-select"
                    value={addUser["newWebsite"]?.period || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        ["newWebsite"]: { ...prev["newWebsite"], period: e.target.value },
                      }))
                    }
                    disabled={!addUser["newWebsite"]?.competition}
                  >
                    <option value="">Select Time period</option>
                    {(addUser["newWebsite"]?.competition === "TopWeb" ? months : years).map(
                      (period, k) => (
                        <option key={k} value={period}>
                          {period}
                        </option>
                      )
                    )}
                  </select>
                </td>

                <td>
                  <select
                    className="form-select"
                    value={addUser["newWebsite"]?.awardType || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        ["newWebsite"]: { ...prev["newWebsite"], awardType: e.target.value },
                      }))
                    }
                    disabled={!addUser["newWebsite"]?.period}
                  >
                    <option value="">Select Award Type</option>
                    {awardTypes.map((type, l) => (
                      <option key={l} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </td>

                <td>
                  <select
                    className="form-select"
                    value={addUser["newWebsite"]?.badge || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        ["newWebsite"]: { ...prev["newWebsite"], badge: e.target.value },
                      }))
                    }
                    disabled={!addUser["newWebsite"]?.awardType}
                  >
                    <option value="">Select Badge</option>
                    {badges.map((badge, l) => (
                      <option key={l} value={badge}>
                        {badge}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <input
                    className="form-control"
                    value={addUser["newWebsite"]?.redirectLink || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        ["newWebsite"]: { ...prev["newWebsite"], redirectLink: e.target.value },
                      }))
                    }
                    disabled={!addUser["newWebsite"]?.badge}
                    placeholder="Enter redirect link"
                  />
                  
                </td>
              </>
            ) : null}
            <td>
              <button
                disabled={(!addUser["newWebsite"]?.awardType || !addUser["newWebsite"]?.redirectLink || !addUser["newWebsite"]?.name || !addUser["newWebsite"]?.competition || !addUser["newWebsite"]?.period || !addUser["newWebsite"]?.badge) && clicked}
                type="button"
                className="btn btn-outline-success uniform-btn"
                style={{ marginBottom: "8px" }}
                onClick={() => {
                  setClicked(true);
                  if (clicked) handleAdd(addUser["newWebsite"]?.name, addUser["newWebsite"]);
                }}
              >
                Add New
              </button>
            </td>
          </tr>

          {Object.keys(groupedUsers).map((key, index) => (
            <React.Fragment key={index}>
              <tr key={key + index}>
                <td rowSpan={expand[key] ? groupedUsers[key].length + 1 : 1}>
                  <span style={{ marginRight: "10px" }}>{key}</span>
                  <span style={{ display: "inline-flex", alignItems: "stretch" }}>
                    {!expand[key] ? (
                      <MdExpandCircleDown onClick={() => handleExpand(key, 1)} style={{ cursor: "pointer" }} />
                    ) : (
                      <MdExpandLess onClick={() => handleExpand(key, 0)} style={{ cursor: "pointer" }} />
                    )}
                  </span>
                </td>
                <td>
                  <select
                    className="form-select"
                    value={getAddUserState(key).competition || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        [key]: { ...prev[key], competition: e.target.value , period:""},
                      }))
                    }
                  >
                    <option value="">Select Competition</option>
                    {competitions.map((competition, j) => (
                      <option key={j} value={competition}>
                        {competition}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    className="form-select"
                    value={getAddUserState(key).period || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        [key]: { ...prev[key], period: e.target.value },
                      }))
                    }
                    disabled={!getAddUserState(key).competition}
                  >
                    <option value="">Select Time period</option>
                    {(getAddUserState(key).competition === "TopWeb" ? months : years).map(
                      (period, k) => (
                        <option key={k} value={period}>
                          {period}
                        </option>
                      )
                    )}
                  </select>
                </td>

                <td>
                  <select
                    className="form-select"
                    value={getAddUserState(key).awardType || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        [key]: { ...prev[key], awardType: e.target.value },
                      }))
                    }
                    disabled={!getAddUserState(key).period}
                  >
                    <option value="">Select Award Type</option>
                    {awardTypes.map((type, l) => (
                      <option key={l} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </td>

                <td>
                  <select
                    className="form-select"
                    value={getAddUserState(key).badge || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        [key]: { ...prev[key], badge: e.target.value },
                      }))
                    }
                    disabled={!getAddUserState(key).awardType}
                  >
                    <option value="">Select Badge</option>
                    {badges.map((badge, l) => (
                      <option key={l} value={badge}>
                        {badge}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <input
                    className="form-control"
                    value={getAddUserState(key).redirectLink || ""}
                    onChange={(e) =>
                      setAddUser((prev) => ({
                        ...prev,
                        [key]: { ...prev[key], redirectLink: e.target.value },
                      }))
                    }
                    disabled={!getAddUserState(key).badge}
                    placeholder="Enter redirect link"
                  />
                    
                </td>
                <td>
                  <div className="d-flex justify-content-start">
                    <button
                      disabled={!addUser[key]?.awardType || !addUser[key]?.redirectLink || !addUser[key]?.competition || !addUser[key]?.period || !addUser[key]?.badge}
                      type="button"
                      className="btn btn-outline-primary uniform-btn"
                      onClick={() => handleAdd(key, addUser[key])}
                    >
                      + Add
                    </button>
                  </div>
                </td>
              </tr>

              {expandGroup[key] &&
                expandGroup[key].map((user, i) => (
                  <tr key={`${index}-${i}`}>
                    <td>
                      <select
                        className="form-select"
                        value={user.competition || ""}
                        onChange={(e) => {
                          const updatedUsers = { ...expandGroup };
                          updatedUsers[key] = [...expandGroup[key]];
                          updatedUsers[key][i] = {
                            ...updatedUsers[key][i],
                            competition: e.target.value,
                            period:""
                          };
                          setExpandGroup(updatedUsers);
                        }}
                      >
                        <option value="">Select Competition</option>
                        {competitions.map((competition, j) => (
                          <option key={j} value={competition}>
                            {competition}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select"
                        value={user.period || ""}
                        onChange={(e) => {
                          const updatedUsers = { ...expandGroup };
                          updatedUsers[key] = [...expandGroup[key]];
                          updatedUsers[key][i] = {
                            ...updatedUsers[key][i],
                            period: e.target.value,
                          };
                          setExpandGroup(updatedUsers);
                        }}
                        disabled={!user.competition}
                      >
                        <option value="">Select Time period</option>
                        {(user.competition === "TopWeb" ? months : years).map((period, k) => (
                          <option key={k} value={period}>
                            {period}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td>
                      <select
                        className="form-select"
                        value={user.awardType || ""}
                        onChange={(e) => {
                          const updatedUsers = { ...expandGroup };
                          updatedUsers[key] = [...expandGroup[key]];
                          updatedUsers[key][i] = {
                            ...updatedUsers[key][i],
                            awardType: e.target.value,
                          };
                          setExpandGroup(updatedUsers);
                        }}
                        disabled={!user.period}
                      >
                        <option value="">Select Award Type</option>
                        {awardTypes.map((type, l) => (
                          <option key={l} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select"
                        value={user.badge || ""}
                        onChange={(e) => {
                          const updatedUsers = { ...expandGroup };
                          updatedUsers[key] = [...expandGroup[key]];
                          updatedUsers[key][i] = {
                            ...updatedUsers[key][i],
                            badge: e.target.value,
                          };
                          setExpandGroup(updatedUsers);
                        }}
                        disabled={!user.awardType}
                      >
                        <option value="">Select Badge</option>
                        {badges.map((badge, l) => (
                          <option key={l} value={badge}>
                            {badge}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <input
                        className="form-control"
                        value={user.redirectLink || ""}
                        onChange={(e) => {
                          const updatedUsers = { ...expandGroup };
                          updatedUsers[key] = [...expandGroup[key]];
                          updatedUsers[key][i] = {
                            ...updatedUsers[key][i],
                            redirectLink: e.target.value,
                          };
                          setExpandGroup(updatedUsers);
                        }}
                        disabled={!user.badge}
                        placeholder="Enter redirect link"
                      />
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        <button
                          disabled = {!user.competition || !user.period || !user.badge || !user.redirectLink || !user.awardType}
                          type="button"
                          className="btn btn-outline-success uniform-btn-change"
                          onClick={() => handleChange(user, key)}
                        >
                          <PencilSquare className="me-0" />
                        </button>
                        <button
                          disabled = {!user.competition || !user.period || !user.badge || !user.redirectLink || !user.awardType}
                          type="button"
                          className="btn btn-outline-danger uniform-btn-delete"
                          onClick={() => handleDelete(user)}
                        >
                          <Trash className="me-0" />
                        </button>
                        <button
                          disabled = {!user.competition || !user.period || !user.badge || !user.redirectLink || !user.awardType}
                          type="button"
                          className="btn btn-outline-primary uniform-btn-change"
                          onClick={() => handleCopyImage(user, key)}
                        >
                          <Image className="me-0" />
                        </button>
                        <button
                          disabled = {!user.competition || !user.period || !user.badge || !user.redirectLink || !user.awardType}
                          type="button"
                          className="btn btn-outline-secondary uniform-btn-change"
                          onClick={() => handleCopyLink(user, key)}
                        >
                          <Link45deg className="me-0" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}